/** @format */
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { LocalizedMarkupString } from 'common-typescript/types';
import { ComponentDowngradeMappings, DowngradedComponent, StaticMembers } from 'sis-common';

@StaticMembers<DowngradedComponent>()
@Component({
    selector: 'sis-localized-markup-string-view',
    templateUrl: './localized-markup-string-view.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LocalizedMarkupStringViewComponent {
    static downgrade: ComponentDowngradeMappings = {
        moduleName: 'sis-components.localizedMarkupStringView',
        directiveName: 'sisLocalizedMarkupStringView',
    };

    @Input({ required: true }) content: LocalizedMarkupString;
    @Input() language?: string;
}
